import { Progress } from '@/components/ui/progress';

interface FormProgressProps {
  mode: 'pages' | 'questions' | 'percentage';
  currentStep: number;
  totalQuestions: number;
  currentPage?: number;
  totalPages?: number;
  progressPercentage: number;
}

export function FormProgress({
  mode,
  currentStep,
  totalQuestions,
  currentPage,
  totalPages,
  progressPercentage,
}: FormProgressProps) {
  const label =
    mode === 'percentage'
      ? 'Progress'
      : mode === 'pages' && currentPage !== undefined && totalPages !== undefined
        ? `Page ${currentPage + 1} of ${totalPages}`
        : `Question ${Math.max(currentStep + 1, 1)} of ${totalQuestions}`;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">{label}</span>
        <span className="font-medium text-foreground">{progressPercentage}%</span>
      </div>
      <Progress value={progressPercentage} className="h-2" />
    </div>
  );
}
